import React, { Component } from "react";
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import {
  sortByDateLatest,
  sortByDateOldest,
  sortByAlphabetAesc,
  sortByAlphabetDesc,
} from '../utils/sort';

import FilterBar from './FilterBar';
import Table from './Table';
import CheckListItems from './CheckListItems';
import Pagnition from './Pagnition';
import Logo from '../components/Logo';

import './ListTable.css';

export default class ListTable extends Component {
  static propTypes = {
      pageOfItems: PropTypes.array,
      items: PropTypes.array,
      header: PropTypes.array,
      content: PropTypes.array,
      children: PropTypes.node,
      renderHeader: PropTypes.func,
      reveal: PropTypes.bool,
      loading: PropTypes.bool,
      renderContent: PropTypes.func,
      createdAt: PropTypes.string,
      filterComponent: PropTypes.node,
  }

  static defaultProps = {
    loading: false,
    createdAt: 'createdAt',
  }

  static contextTypes = {
    store: PropTypes.object,
  }

  constructor(props) {
    super(props);
    let { items } = props;
    if (items && items.length > 0) {
      items = items.sort(this.getSort());
    }
    this.state = {
      items,
      pageOfItems: props.pageOfItems || [],
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleSticky, true);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleSticky, true);
  }

  async componentWillReceiveProps(nextProps) {
    if (nextProps.items !== this.props.items) {
      let { items } = nextProps;
      if (items && items.length > 0) {
        items = items.sort(this.getSort());
      }
      this.setState({ items });
    }
  }

  onChangePage = async (pageOfItems, reveal) => {
    if (this.props.onChangePage) {
      return this.props.onChangePage;
    }  else {
      this.setState({ pageOfItems, reveal });
    }
  }

  onReveal = async (reveal) => {
    this.setState({ reveal });
  }

  getSort = () => {
    const { currentSort } = this.props;
    const { createdAt } = this.props;
    if (currentSort) {
      switch (currentSort.eventKey) {
        case 'oldestDate':
          return sortByDateOldest(createdAt);
        case 'ascName':
          return sortByAlphabetAesc('name');
        case 'descName':
          return sortByAlphabetDesc('name');
        default:sortByDateLatest(createdAt);
      }
    }
    return sortByDateLatest(createdAt);
  }

  handleSticky() {
    const header = document.getElementById("firstRow");

   if (window.pageYOffset >= 5) {
       header.classList.add("sticky");
     } else {
       header.classList.remove("sticky");
     }
   }

    render() {
      const {
        currentSelect,
        onChange,
        types,
        onSelect,
        currentSort,
        sortTypes,
        onSelectSort,
        loading,
        printName,
        printLink,
        filterComponent,
        header,
        renderHeader,
        renderContent,
      } = this.props;
      const { pageOfItems, reveal, items } = this.state;
      return (
        <div>
          <FilterBar
            title={currentSelect ? currentSelect.label : 'Select'}
            onChange={onChange}
            types={types}
            onSelect={onSelect}
            sortTitle={currentSort ? currentSort.label : 'Select'}
            sortTypes={sortTypes}
            onSelectSort={onSelectSort}
            disabled={loading}
            printName={printName}
            printLink={printLink}
            filterComponent={filterComponent}
          />
          <Table className="ListTable">
            <Table.Header id="firstRow">
              {
                header.map((i, idx) => {
                  if (renderHeader) {
                    return renderHeader(i, idx);
                  }
                  return (<div className="col" key={idx}>{i}</div>);
                })
              }
            </Table.Header>
              
            { 
              loading ?
                <Row className="defaultRow">
                    <Col xs={12}>
                      <Logo medium spin />
                    </Col>
                  </Row>
              :
              <span>
                {
                  pageOfItems && pageOfItems.length > 0 ?
                  <Table.Body>
                    {
                      renderContent ?
                        renderContent({
                          pageOfItems: pageOfItems,
                          reveal: reveal,
                          onReveal: this.onReveal,
                        })
                      :
                      <CheckListItems
                        checks={pageOfItems}
                        reveal={reveal}
                        onReveal={this.onReveal}
                      />
                    }
                    </Table.Body>
                    :
                    <Row className="defaultRow">
                      <Col xs={12}>
                        <h4>No Record</h4>
                      </Col>
                    </Row>
                  }
              </span>
            }
            <Pagnition items={items} onChangePage={this.onChangePage} />
          </Table>
        </div>
      );
    }
  }



// WEBPACK FOOTER //
// ./src/components/ListTable.jsx